import { memo } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import { usePlaybackJumpNavigation } from '../hooks/usePlaybackJumpNavigation';

const JumpForward = () => {
  const { onJumpForward, isJumpForwardDisabled } = usePlaybackJumpNavigation();

  return (
    <PlayerTimelineButton
      tooltipTitle="Skip 5s forward"
      buttonId="jump-forward-button"
      onClick={onJumpForward}
      isDisabled={isJumpForwardDisabled}
      iconName="IconPlayerSkipForward"
    />
  );
};

export default memo(JumpForward);
